import { useTranslations } from 'next-intl'
import { useDestinationContext } from '@/src/contexts'
import EditorialMeta from '@/src/components/common/srp/flightSchedule/routeSeoContent/editorialMeta/editorialMeta'

const DestinationEditorialMetaWrapper = () => {
    const t = useTranslations('destinationPage')
    const { destinationData: { sections } } = useDestinationContext()
    const editorialMeta = sections.editorialMeta
    if (!editorialMeta) return null

    const lines: string[] = []
    if (editorialMeta.methodology) lines.push(editorialMeta.methodology)
    if (editorialMeta.reviewedBy) lines.push(t('reviewedBy', { name: editorialMeta.reviewedBy }))

    if (!lines.length) return null

    return <EditorialMeta lines={lines} />
}

export default DestinationEditorialMetaWrapper
